import React from 'react';
import DemoPage from './DemoPage';

const Underwriting: React.FC = () => (
  <DemoPage
    title="Underwriting"
    videoSrc="/videos/underwriting_demo.mp4"
    description="Drop an OM and get a decision. Extracts the rent roll and T-12, pulls comps from the same submarket, runs cash flow and returns, and flags every claim that doesn’t hold up. Your deal-flow AI learns about your strategies and makes smarter decisions over time."
  />
);

export default Underwriting;
